import sidebar from '@/css/module/sidebar.css';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAliases } from '@/store-selectors';
import Layer from '@/components/layers/Layer';
import { SUGGESTION_APPLIED, SUGGESTIONS_CHANGED } from '@/actions/constants';
import { completed } from '@/actions/helpers';
import { getStepsSuggestions } from '@/features/suggestions/store-selectors';
import { Island, IslandButton, TrevorIcon } from '@trevor/ui-components';

export type SuggestedSummarizeStepProps = {
  layer: Layer;
  layerNum: number;
  templateAggregateLayer: number;
  layers: Layer[];
};
export const SuggestedSummarizeStep: React.FC<SuggestedSummarizeStepProps> = ({
  layer,
  layerNum,
  templateAggregateLayer,
  layers,
}) => {
  const aliases = useSelector(getAliases);
  const dispatch = useDispatch();
  const { suggestions: suggestedSteps } = useSelector(getStepsSuggestions);

  const onSuggestionRemove = (id: number) => {
    dispatch(
      completed(
        SUGGESTIONS_CHANGED,
        suggestedSteps.filter((l) => l.id() !== id),
      ),
    );
  };

  const layerToReplace = layers[templateAggregateLayer] ?? null;

  const activateSuggestion = (suggestedLayer: Layer) => {
    dispatch(
      completed(SUGGESTION_APPLIED, {
        newLayer: suggestedLayer,
        layerToReplace,
      }),
    );
  };

  return (
    <div className={`${sidebar.layer} sidebarLayer layer position-relative`}>
      <div className={`${sidebar.layerInner} ${sidebar.inactiveStep}`}>
        <div className={sidebar.stepNumberContainer}>
          <div className={sidebar.stepNumber}>{layerNum}</div>
        </div>
        <div className={sidebar.layerTypeContainer}>
          <div className={sidebar.layerType}>summarize</div>
        </div>
        <div className={sidebar.layerContent}>
          <div>{layer.buildContent(() => {}, aliases)}</div>
        </div>
      </div>

      <div className={sidebar.reactiveLayer}>
        <div className={sidebar.layerControl}>
          <Island size="small">
            <IslandButton
              content="Activate"
              tooltipContent="Activate suggestion"
              onClick={() => activateSuggestion(layer)}
            />
            <IslandButton
              content={<TrevorIcon name="trash-bin" />}
              tooltipContent="Delete suggestion"
              onClick={() => onSuggestionRemove(layer.id())}
            />
          </Island>
        </div>
      </div>
    </div>
  );
};
